import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Slider from './slider';
import Icon from '../icon';

const LINK_CLASS = "nav-link";

class NavBar extends React.Component {

  constructor (props){
    super (props);

    this.setElement =  this.setElement.bind (this);
    this.getcurIndex = this.getcurIndex.bind (this);
    this.setMenu = this.setMenu.bind (this);

    this.state = {
      element: undefined,
      open: false
    }
  }
  
  setElement (navbar) {
    // window must be fully loaded before elements can be styled
    window.addEventListener ('load', () => {
      this.setState({
        element: navbar
      })
    })
  }

  getcurIndex (url){
    for (let i = 0; i < this.props.links.length; ++i){
      let linkUrl = this.props.links[i].url
      if (url === linkUrl) {
        return i;
      }
    }
    return undefined;
  }

  animateSlider (navbar) {
    if (!navbar) {
      return false;
    }
    let activeLink = navbar.getElementsByClassName ('active')[0];
  }

  setMenu (isOpen) {
    this.setState ({
      open: isOpen
    })
  }

  isAbsolute (url) {
    return url.indexOf ('http://') === 0 || 
      url.indexOf ('https://') === 0;
  }

  navItem (curIndex, {name, url}, index) {
    const lowerCaseUrl  = url.toLowerCase ();
    let item = undefined;
    if (!this.isAbsolute (lowerCaseUrl)){
      item = (
        <Link to={url} onClick={this.setMenu.bind (this, false)}>
          {name}
        </Link>
      )
    }
    else {
      item = (
        <a href={url} target="_blank" onClick={this.setMenu.bind (this, false)}>
          {name}
        </a>
      )
    }
    return (
      <div 
        className={classNames (LINK_CLASS, {'active': index === curIndex})}
        key={index} 
      >
        {item}
      </div>
      )
  }

  render () {
    let curIndex = this.getcurIndex (this.props.location.pathname);
    let curNavItemGenerator = this.navItem.bind (this, curIndex);
    
    let left = 0;
    let width = 0;
    if (curIndex !== undefined && this.state.element) {
      let link = this.state.element.getElementsByClassName (LINK_CLASS)[curIndex];
      let parentBox = link.parentElement.getBoundingClientRect ();
      let linkBox = link.getBoundingClientRect ();
      left = linkBox.left - parentBox.left;
      width = linkBox.right - linkBox.left;
    }

    let color = this.props.color;

    const navStyle = {}
    if (color != undefined){
      Object.assign (navStyle, { 
        color: color,
        stroke: color
      });
    }

    const navItems = this.props.links.map (curNavItemGenerator);

    const linkContainerClasses = classNames (
      "nav-bar--link-container",
      "h6",
      { "open": this.state.open},
    )

    return (
      <header 
        className="nav-bar" 
        ref={this.setElement}
        style={navStyle}
      >
        <Icon
          symbol={Icon.SYMBOL.MENU}
          className="nav-bar--icon"
          onClick={this.setMenu.bind (this, true)}
        />
        <div className={linkContainerClasses}>
          <div className="nav-bar--link-header">
            <Icon
              symbol={Icon.SYMBOL.EXIT}
              className="nav-bar--exit"
              onClick={this.setMenu.bind (this, false)}
            />
          </div>
          { navItems }
          <div className="nav-bar--mobile-items">
            { this.props.mobileItems }
          </div>
          <Slider left={left} width={width} color={color}/>
        </div>
        <div className="nav-bar--logo-container">
          {React.Children.only(this.props.children)}
        </div>
      </header>
    )
  }
}

export default NavBar;


// WEBPACK FOOTER //
// ./components/nav-bar/index.js